import React from "react";
import EmbateComingSoon from "./EmbateComingSoon.jsx";

function App() {
  return <EmbateComingSoon />;
}

export default App;
